declare function require(name: string);
declare let global: {
    platform: string;
};

import { PlatformKind, DeviceType } from './common';

type UnionKeyToValue<U extends string, V> = {
    [K in U]: V
};

const PlatformKindValues = Object.freeze<UnionKeyToValue<PlatformKind, PlatformKind>>({
    android: 'android',
    ios: 'ios',
    desktop: 'desktop'
});

const deviceOSMap: UnionKeyToValue<PlatformKind, string> = {
    android: 'Android',
    ios: 'iOS',
    desktop: 'Desktop',
}

const deviceTypeMap: UnionKeyToValue<DeviceType, string> = {
    web: 'Web',
    native: 'Native'
}

const getMobilePlatform = () => {
    // tslint:disable-next-line: no-implicit-dependencies
    return require('react-native').Platform;
};
const UNKNOWN_PLATFORM = 'Unknown platform';
export const Platform = {
    get deviceType(): DeviceType {
        return Platform.isDesktop ? 'web' : 'native';
    },

    get kind(): PlatformKind {
        if (Platform.isDesktop) {
            return PlatformKindValues.desktop;
        }

        const mobilePlatform = getMobilePlatform();

        if (mobilePlatform.OS === PlatformKindValues.android) {
            return PlatformKindValues.android;
        }

        if (mobilePlatform.OS === PlatformKindValues.ios) {
            return PlatformKindValues.ios;
        }

        throw new Error(UNKNOWN_PLATFORM);
    },

    get isDesktop() {
        return ('platform' in global) &&
            global.platform === PlatformKindValues.desktop;
    },

    get isIOS() {
        return Platform.kind === PlatformKindValues.ios;
    },

    get isAndroid() {
        return Platform.kind === PlatformKindValues.android;
    },

    formatter: {
        get deviceType(): string {
            const result = deviceTypeMap[Platform.deviceType];

            if (!result) {
                throw new Error(UNKNOWN_PLATFORM);
            }

            return result;
        },

        get deviceOs(): string {
            const result = deviceOSMap[Platform.kind];

            if (!result) {
                throw new Error(UNKNOWN_PLATFORM);
            }

            return result;
        }
    }
};
